// extracted by mini-css-extract-plugin
export default {"img":"mainBlog_img__V1-lk","btn":"mainBlog_btn__pdbKu","heading":"mainBlog_heading__NikdD","readmore":"mainBlog_readmore__DQl1n","desc":"mainBlog_desc__nLyoS"};